module.exports = __webpack_public_path__ + "static/media/income.7050ce6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/income.svg
// module id = 466
// module chunks = 0